import {
  formatVotableOrder,
  VOTABLE_ORDERS,
  VotableOrder,
} from "../utils/votableOrder";
import { OrderSelect } from "./OrderSelect";

export interface VotableOrderSelectProps {
  readonly value: Readonly<VotableOrder>;
  readonly onChange: (value: Readonly<VotableOrder>) => void;
}

export default function VotableOrderSelect({
  value,
  onChange,
}: VotableOrderSelectProps) {
  return (
    <OrderSelect
      order={value}
      orders={VOTABLE_ORDERS}
      format={formatVotableOrder}
      onChange={onChange}
    />
  );
}
